function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Header, withContext } from '../../components';
import { crumbDataDefault, pagesDefault, subPagesDefault } from './data';
import { fetchMsgList, readAll, readMsg } from './actions';

var ReduxHeader = /*#__PURE__*/function (_Component) {
  _inherits(ReduxHeader, _Component);

  var _super = _createSuper(ReduxHeader);

  function ReduxHeader(props) {
    var _this;

    _classCallCheck(this, ReduxHeader);

    _this = _super.call(this, props);
    _this.handleReadAllMsg = _this.handleReadAllMsg.bind(_assertThisInitialized(_this));
    _this.handleReadMsgItem = _this.handleReadMsgItem.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReduxHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dispatch = this.props.dispatch;
      var ds = this.context.ds;
      dispatch(fetchMsgList(ds));
    }
    /* componentDidUpdate() {
     *     const { dispatch } = this.props;
     *     const { ds, siteId } = this.context;
     *     if (siteId && siteId !== this.nowSiteId) {
     *         this.nowSiteId = siteId;
     *         dispatch(fetchMsgList(ds));
     *     }
     * } */

  }, {
    key: "handleReadAllMsg",
    value: function handleReadAllMsg() {
      var dispatch = this.props.dispatch;
      var ds = this.context.ds;
      dispatch(readAll(ds));
    }
  }, {
    key: "handleReadMsgItem",
    value: function handleReadMsgItem(msgId) {
      var dispatch = this.props.dispatch;
      var ds = this.context.ds;
      dispatch(readMsg(ds, {
        msgId: msgId
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          crumbData = _this$props.crumbData,
          userInfo = _this$props.userInfo,
          pages = _this$props.pages,
          subPages = _this$props.subPages,
          msgList = _this$props.msgList,
          curPage = _this$props.curPage,
          curSubPage = _this$props.curSubPage,
          unreadNum = _this$props.unreadNum;
      return /*#__PURE__*/React.createElement(Header, {
        crumbData: crumbData,
        userInfo: userInfo,
        pages: pages,
        subPages: subPages,
        showMsg: true,
        msgList: msgList,
        curPage: curPage,
        curSubPage: curSubPage,
        unreadNum: unreadNum,
        onReadAllMsg: this.handleReadAllMsg,
        onReadMsgItem: this.handleReadMsgItem,
        inviteCode: "8888888"
      });
    }
  }]);

  return ReduxHeader;
}(Component);

ReduxHeader.defaultProps = {
  crumbData: crumbDataDefault,
  userInfo: {},
  pages: pagesDefault,
  subPages: subPagesDefault,
  msgList: [],
  curPage: '建站',
  curSubPage: '页面编辑',
  unreadNum: 0
};
ReduxHeader.propTypes = {
  crumbData: PropTypes.arrayOf(PropTypes.object),
  userInfo: PropTypes.shape({}),
  pages: PropTypes.arrayOf(PropTypes.object),
  subPages: PropTypes.arrayOf(PropTypes.array),
  msgList: PropTypes.arrayOf(PropTypes.object),
  curPage: PropTypes.string,
  curSubPage: PropTypes.string,
  unreadNum: PropTypes.number
};
export default connect(function (state) {
  var _state$passport = state.passport,
      userName = _state$passport.userName,
      status = _state$passport.status,
      verificationType = _state$passport.verificationType,
      verificationStatus = _state$passport.verificationStatus,
      inWhiteList = _state$passport.inWhiteList;
  var _state$header = state.header,
      msgList = _state$header.msgList,
      unreadNum = _state$header.unreadNum;
  return {
    userInfo: {
      userName: status === 'online' ? userName : '',
      verificationType: verificationType,
      verificationStatus: verificationStatus,
      inWhiteList: inWhiteList
    },
    msgList: msgList,
    unreadNum: unreadNum
  };
})(withContext(ReduxHeader));